// Restaurant ID utilities
export const getRestaurantId = () => localStorage.getItem('restaurantId');

export const setRestaurantId = (restaurantId: string) => {
  localStorage.setItem('restaurantId', restaurantId);
};

export const clearRestaurantId = () => {
  localStorage.removeItem('restaurantId');
};
